import * as React from 'react'
import { SVGProps } from 'react'

export const TagManagerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 16}
    height={props.height ?? 16}
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.1745 46.5522L19.8428 38.4277L37.7362 20.1553L46.3624 28.6097L28.1745 46.5522Z"
      fill="#6A6A6A"
    />
    <path
      d="M28.2099 10.6318L19.9082 2.15552L1.75571 20.1362C-0.584259 22.4761 -0.584259 26.2697 1.75571 28.6124L19.6355 46.6094L28.0899 38.7005L14.4673 24.3743L28.2099 10.6318Z"
      fill="#4D4D4D"
    />
    <path
      d="M46.2424 20.2753L28.2427 2.27558C25.9 -0.0671188 22.1009 -0.0671188 19.7582 2.27558C17.4155 4.61827 17.4155 8.41731 19.7582 10.76L37.758 28.7597C40.1007 31.1024 43.8997 31.1024 46.2424 28.7597C48.5851 26.4171 48.5851 22.618 46.2424 20.2753Z"
      fill="#6A6A6A"
    />
    <path
      d="M23.8626 48.5186C27.1009 48.5186 29.7261 45.8934 29.7261 42.6551C29.7261 39.4167 27.1009 36.7915 23.8626 36.7915C20.6242 36.7915 17.999 39.4167 17.999 42.6551C17.999 45.8934 20.6242 48.5186 23.8626 48.5186Z"
      fill="#282421"
    />
  </svg>
)
